import module from 'kendu/legacy/module'
import angular from 'angular'

function $schema ($log) {
  function transform (value, type, encode) {
    if (value === null || typeof value === 'undefined') {
      return value
    }

    try {
      switch (type) {
        case 'date':
          if (encode) {
            return dateEncode(value)
          } else {
            return dateDecode(value)
          }
        case 'timestamp':
        case 'datetime':
          if (encode) {
            return datetimeEncode(value)
          } else {
            return datetimeDecode(value)
          }
        case 'array':
          return encode ? value.join(',') : (value === '' ? [] : value.split(','))
        case 'number':
          return encode ? String(value) : parseFloat(value)
        case 'unixTimestamp':
          return encode ? value.getTime() : new Date(value)
        case 'boolean':
          if (encode) {
            return value ? '1' : '0'
          } else {
            return value === '1' || value === 1
          }
        case 'json':
          if (encode) {
            return JSON.stringify(value)
          } else {
            return JSON.parse(value)
          }
        default:
          return value
      }
    } catch (e) {
      $log.error('Unable to convert ' + type, value)

      return value
    }
  }

  function dateEncode (value) {
    if (value === null) {
      return '0000-00-00'
    }

    return value.toISOString().slice(0, 10)
  }

  function dateDecode (value) {
    if (value === '0000-00-00') {
      return null
    }

    let d = value.split('-')

    return new Date(d[0], d[1] - 1, d[2])
  }

  function datetimeEncode (value) {
    if (value === null) {
      return '0000-00-00 00:00:00'
    }

    return value.toISOString().slice(0, 19).replace('T', ' ')
  }

  function datetimeDecode (value) {
    if (value === '0000-00-00 00:00:00') {
      return null
    }

    let d = value.split(/[- :]/)

    return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5])
  }

  return function $schema (obj, format, stringify) {
    if (angular.isArray(obj)) {
      return obj.map((item) => $schema(item, format, stringify))
    } else {
      let result = angular.copy(obj)

      angular.forEach(format, (type, property) => {
        if (result && result.hasOwnProperty(property)) {
          if (angular.isObject(type)) {
            result[property] = $schema(result[property], type, stringify)
          } else {
            result[property] = transform(result[property], type, stringify)
          }
        }
      })

      return result
    }
  }
}

module.service('$schema', $schema)



// WEBPACK FOOTER //
// ./src/deprecated/services/$schema.js